<div class="loading-progress-bar">
    <div class="loading-progress-bar__bar"></div>
</div>
